<div #container class="nc-liquid-ether-canvas-container" [style.background-color]="ncBgColor"></div>
<div class="nc-content-wrapper">
    <ng-content></ng-content>
</div>